function planKey(plan) {
  return ((plan && (plan.pricing_id || plan.plan_code)) || '').toUpperCase();
}

function findMoStandardPlan(pricePlans) {
  const active = (pricePlans || []).filter(function (p) {
    return p.status === 'ACTIVE';
  });
  return (
    active.find(function (p) {
      return (
        p.loan_term === '12M' ||
        /MOSTANDARD(25|35)/.test(planKey(p)) ||
        /^MOSTANDARD/i.test(p.plan_code || '')
      );
    }) || null
  );
}

function findMoSaverPlan(pricePlans) {
  const active = (pricePlans || []).filter(function (p) {
    return p.status === 'ACTIVE';
  });
  return (
    active.find(function (p) {
      return p.loan_term === '3M' || planKey(p).includes('MOSAVER');
    }) || null
  );
}

function findMoLitePlan(pricePlans) {
  const active = (pricePlans || []).filter(function (p) {
    return p.status === 'ACTIVE';
  });
  const mostandard = findMoStandardPlan(pricePlans);
  return (
    active.find(function (p) {
      return p.loan_term === 'STDHIGH' && p !== mostandard;
    }) || null
  );
}

function getMoStandardDisplayPricing(plan) {
  if (!plan) return { weekly: null, deposit: null };
  return {
    weekly: plan.fin_12_month_weekly,
    deposit: plan.fin_deposit,
  };
}

function getMoSaverDisplayPricing(plan) {
  if (!plan) return { weekly: null, deposit: null };
  return {
    weekly: plan.fin_3_month_weekly,
    deposit: plan.fin_deposit,
  };
}

function formatKes(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n.toLocaleString('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
